import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Minimal "X - Y of Z" pager with prev/next arrows only (no page-number
 * buttons). Used instead of `nz-pagination`'s `nzSimple` mode, which does
 * not support rendering a total-count label at all.
 */
@Component({
  selector: "app-simple-pager",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./simple-pager.component.html",
  styleUrl: "./simple-pager.component.scss",
})
export class SimplePagerComponent {
  @Input() start = 0;
  @Input() end = 0;
  @Input() total = 0;
  @Input() disablePrev = false;
  @Input() disableNext = false;

  @Output() prev = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
}
